(function (angular, app) {
   "use strict";
    
   // Focus
   angular.module(app.modules.common.name)
      .directive(app.modules.common.directives.focus, FocusDirective); 
      
   FocusDirective.$inject = [];
   
   function FocusDirective() {
      return {
         restrict : "A",
         link: function(scope, element, attrs) {
            scope.$watch(attrs.isfocus, function(value) {
               console.log("focus: " + attrs.isfocus)
                if(value === true) {
                    element[0].focus();
                    element[0].select();
                }
            });
         }
      }
   }
}(angular, app));
